import { useEffect } from 'react';

interface SchemaOrgData {
  '@context': string;
  '@type': string;
  [key: string]: any;
}

export const useSchemaOrg = (schemaData: SchemaOrgData | SchemaOrgData[]) => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const processSchema = (schema: SchemaOrgData): SchemaOrgData => {
      const processed = { ...schema };
      
      // Replace placeholder URLs with actual site URL
      Object.keys(processed).forEach(key => {
        if (typeof processed[key] === 'string' && processed[key].includes('SITE_URL')) {
          processed[key] = processed[key].replace(/SITE_URL/g, siteUrl);
        } else if (typeof processed[key] === 'object' && processed[key] !== null) {
          processed[key] = processSchema(processed[key]);
        }
      });
      
      return processed;
    };

    const schemas = Array.isArray(schemaData) ? schemaData : [schemaData];
    const scriptElements: HTMLScriptElement[] = [];

    schemas.forEach(schema => {
      const processedSchema = processSchema(schema);
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(processedSchema);
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    return () => {
      scriptElements.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [schemaData]);
};
